<template>
	<div class="container2">
		<div class="main">
			<div class="main-img">
				<el-carousel :interval="5000" arrow="always" class="main-img-all">
					<el-carousel-item v-for="(item,index) in imglist" :key="index" class="main-img-lb">
						<el-image class="main-img1"
							:src="item.img"></el-image>
					</el-carousel-item>
				</el-carousel>
			</div>
			<div class="menu">
				<div class="menu-left">
					<div class="menu-left1">深圳乐园互联网科技有限公司-公司介绍</div>
					<div class="menu-left2">
						<span>深圳乐园互联网科技有限公司,招商总部位于创新之都深圳，是一家集科技创新、物联网信息技术开发的高新企业，</span>
						<span style="color: rgb(230, 74, 25);">主营能量工厂共享充电线</span>
						<span>项目开始初期即获得A轮融资数亿元，深圳乐园互联网科技有限公司作为深圳共享充电线厂家，拥有多项技术和产品专利，自有硬件生产基地，
						自建工厂位于广东深圳。目前产品已经正式上线并量产，日产量5000套设备。</span>
						<span>作为共享充电线源头厂家，提供共享充电线加盟代理和OEM贴牌定制代工服务，合作</span>
						<span style="color: rgb(230, 74, 25);">分润100%总部0抽成</span>
						<span>,能量工厂快充共享充电线全新上线，全球招募共享充电线代理加盟商一起发展，分享共享经济市场的红利。</span>
					</div>
					<div class="menu-left3">至今已经发展了包括香港，澳门，马来西亚，泰国，英国，意大利等全球40多个国家地区的国内外共享充电业务。能量工厂共享充电线厂家招商合作
					，为您提供一站式共享充电线解决方案。</div>
				</div>
				<div class="menu-right">
					<img  src="../../assets/img/main/nlgc3.jpeg"/>
				</div>
			</div>
			<div class="menu2">
				<div class="menu2-1" v-for="item in flglist">
					<div class="menu2-1-top">{{item.time}}</div>
					<div class="menu2-1-top2">{{item.name}}</div>
				</div>
			</div>
			<div class="menu3">
				<div class="menu3-top">
					<div class="menu3-top1">产品展示</div>
					<div class="menu3-top2">共享充电线、共享充电线等多款型号，源头厂家库存充足适用于各类商户场景，包含桌面式共享充电线机柜，立式多媒体共享充电线广告机，</div>
					<div class="menu3-top2">酒店扫码共享充电线等，搭配投放效果更佳，共享充电线加盟，共享WiFi贴加盟一次投放持续获利，手机远程管理后台，持续躺赚。</div>
				</div>
			</div>
			<div class="menu4">
				<div class="menu4-all">
					<div class="menu4-all-img1">
						<!-- <el-image src="../../assets/img/main/1.jpeg"></el-image> -->
						<img src="../../assets/img/cable/nlgc1.png"/>
					</div>
					<div class="menu4-all-text">能量工厂充电线</div>
					<div class="menu4-all-text2">
						<span>用户能一眼清晰辨认使用方法及售后电话使用起来非常方便快捷，支持支付宝与微信使用门槛低无需信用分</span>
						<span style="color: rgb(230, 74, 25);">终身免费补线、换、补</span>
					</div>
				</div>
			<!-- 	<div class="menu4-all">
					<div class="menu4-all-img">
						<el-image src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"></el-image>
					</div>
					<div class="menu4-all-text">倍爱盒酒店售货机</div>
					<div class="menu4-all-text2">
						<span>能量工厂研发的酒店迷你售货机，</span>
						<span style="color: rgb(230, 74, 25);">可放在酒店床头售卖成人、情趣用品，</span>
						<span>搭配共享充电线一起组合售卖，利润高达500%以上，专利产品支持OEM</span>
					</div>
				</div> -->
				<div class="menu4-all">
					<div class="menu4-all-img1">
						<!-- <el-image src="../../assets/img/cable/10.jpg"></el-image> -->
						<img src="../../assets/img/cable/nlgc2.jpg" />
					</div>
					<div class="menu4-all-text">能量工厂共享充电线</div>
					<div class="menu4-all-text2">
						<span>能量工厂共享充电线为自主研发生产，主要投放在酒店、宾馆、网吧等室内场所，扫码即用，</span>
						<span style="color: rgb(230, 74, 25);">代理商自定义租借价格，分润100%质保半年以换代修</span>
					</div>
				</div>
			</div>
			<div class="menu5">
				<div class="menu3-top">
					<div class="menu3-top1">能量工厂集团-快充共享充电线品牌厂家</div>
					<div class="menu3-top2">
						<span>共享行业知名品牌-全球共享充电线行业前五，</span>
						<span style="color: rgb(230, 74, 25);">快充共享充电线</span>
						<span>源头工厂，品牌厂家</span>
					</div>
				</div>
				<div class="menu5-1">
					<div class="menu5-all">
						<div class="menu4-all-img">
							<el-image class="menu4-all-img2" src="//16856361.s21i.faiusr.com/4/ABUIABAEGAAg-tqarAYorvi4sgIwsAk4sAk.png"></el-image>
						</div>
						<div class="menu4-all-text">自媒体品宣</div>
						<div class="menu4-all-text2">我司有完整的互联网推广服务，包括但不限于：搜索引擎软文广告、抖音增粉、点赞、播放量等服务</div>
					</div>
				<div class="menu5-all">
					<div class="menu4-all-img">
						<el-image class="menu4-all-img2" src="//16856361.s21i.faiusr.com/4/ABUIABAEGAAgyYGsqgYoovP_-QUwsAk4sAk.png"></el-image>
					</div>
					<div class="menu4-all-text">礼品赠送</div>
					<div class="menu4-all-text2">我司每月会寄送礼品给符合条件的酒店协助酒店邀约用户点评好评，礼品包括但不限于：盲盒、计生用品、洗护用品等</div>
				</div>
				<div class="menu5-all">
					<div class="menu4-all-img">
						<el-image class="menu4-all-img2" src="//16856361.s21i.faiusr.com/4/ABUIABAEGAAgpIKsqgYosuLBwAUwsAk4sAk.png"></el-image>
					</div>
					<div class="menu4-all-text">私域平台搭建</div>
					<div class="menu4-all-text2">我司提供微信小程序、微信公众号、支付宝小程序、企业微信、企业支付宝、阿里云账户、腾讯云账户、抖音官方账号代申请服务</div>
				</div>
				<div class="menu5-all">
					<div class="menu4-all-img">
						<el-image class="menu4-all-img2" src="//16856361.s21i.faiusr.com/4/ABUIABAEGAAgz4KsqgYot8bixQUwsAk4sAk.png"></el-image>
					</div>
					<div class="menu4-all-text">差评处理</div>
					<div class="menu4-all-text2">差评极大的影响了酒店的订单量。我司每月针对符合条件的酒店免费处理美团差评，针对无法处理差评的平台，我司会提供方案增加好评，降低差评的影响</div>
				</div>
				</div>
			</div>
		<!-- 	<div class="fotter">
				<div class="fotter1">
					<div class="fotter1-text">
						<span class="color-text3">能量工厂</span>
						<span>官网-深圳市乐园互联网科技有限公司</span>
					</div>
					<div class="fotter1-text2">
						<div class="fotter1-text2-1">
							<span>能量-全球十大</span>
							<span class="color-text">共享充电线</span>
							<span>品牌之一，</span>
							<span class="color-text2">能量工厂3c认证</span>
						</div>
						<div class="fotter1-text2-2">
							<span class="fotter1-text2-2-left color-text3">共享充电线</span>
							<span>，共享充电线加盟代理，</span>
							<span class="fotter1-text2-2-left color-text3">共享WiFi贴</span>
							<span>，酒店售货机厂家招商加盟</span>
						</div>
						<div class="fotter1-text2-3">
							<span>代理加盟咨询招商总监：王总 </span>
							<span class="color-text3">18664573264</span>
							<span> 微信同号</span>
						</div>
						<div class="fotter1-text2-4">
							<span>公司总部：广东省深圳市宝安区新桥街道上星社区上星路万科星城星宸大厦第3栋6楼整层</span>
						</div>
					</div>
				</div>
				<div class="fotter2">
					<el-image src="../../assets/img/erweim1.png"></el-image>
				</div>
			</div> -->
			<div class="fotter">
				<div class="fotter1">
					<div class="fotter1-text">
						<span class="color-text3">能量工厂</span>
						<span>官网-深圳市乐园互联网科技有限公司</span>
					</div>
					<div class="fotter1-text2">
						<div class="fotter1-text2-1">
							<span>能量工厂-全球十大</span>
							<span class="color-text">共享充电线</span>
							<span>品牌之一，</span>
							<span class="color-text2">能量工厂3c认证</span>
						</div>
						<div class="fotter1-text2-2">
							<span class="fotter1-text2-2-left color-text3">共享充电线</span>
							<span>，共享充电宝加盟代理，</span>
							<span class="fotter1-text2-2-left color-text3">共享WiFi贴</span>
							<span>，酒店售货机厂家招商加盟</span>
						</div>
						<div class="fotter1-text2-3">
							<span>代理加盟咨询老板：刘总 </span>
							<span class="color-text3">15899889999</span>
							<span> 微信同号</span>
						</div>
						<div class="fotter1-text2-4">
							<span>公司总部：广东省深圳市宝安区新桥街道上星社区上星路万科星城星宸大厦第3栋6楼整层</span>
						</div>
					</div>
				</div>
				<div class="fotter2">
					<!-- <el-image src="../../assets/img/cable/guanfang.jpg"></el-image> -->
					<!-- <img src="../../assets/img/cable/guanfang.jpg"/> -->
					<!-- <img src="../../assets/img/product/erweima.png"/> -->
					<img src="../../assets/jiudianbao.jpg"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeName: '0',
				imglist:[
					// {
					// 	id:1,
					// 	img:require('../../assets/img/main/1.jpeg')
					// },
					{
						id:1,
						img:require('../../assets/img/main/9.jpeg')
					},
					// {
					// 	id:3,
					// 	img:require('../../assets/img/main/7.jpeg')
					// },
					// {
					// 	id:2,
					// 	img:require('../../assets/img/main/8.jpeg')
					// },
					
				],
				flglist:[
					{
						id:1,
						name:'入场共享行业',
						time:2018
					},
					{
						id:1,
						name:'第一代产品上线',
						time:2019
					},
					{
						id:1,
						name:'进军共享充电线行业',
						time:2020
					},
					{
						id:1,
						name:'成为共享充电线行业TOP前三',
						time:2021
					},
				]
			}
		},
		computed:{
			
		},
		methods: {
			handleClick(tab, event) {
				this.activeName = tab.index;
				console.log('this.activeName',this.activeName);
			},
		}
	}
</script>

<style scoped>
	.container2{
		background: #f7f7f7;
		/* border-bottom: 1px solid #ddd; */
		border-radius: 5px;
		margin-bottom: 20px;
	}
	/deep/ .el-carousel__arrow{
		display: none !important;
	}
	.main-img-all {
		width: 100%;
	}
	
	.main-img-lb {
		/* height: 420px; */
	}
	::v-deep .el-carousel__container {
		min-height: 440px;
	}
	
	.main-img1 {
		width: 100%;
		height: 440px;
	}
	.menu{
		display: flex;
		padding: 50px 50px;
		/* justify-content: center; */
	}
	.menu-left{
		width: 50%;
		text-align: left;
	}
	.menu-left1{
		font-size: 24px;
		font-weight: bold;
	}
	.menu-left2{
		margin-top: 20px;
		line-height: 40px;
	}
	.menu-left3{
		margin-top: 10px;
	}
	.menu-right{
		width: 50%;
		margin-left: 5%;
	}
	.menu-right img{
		width: 100%;
		height: 300px;
	}
	.menu2{
		display: flex;
		align-items: center;
		background: #5f78f8;
		color: aliceblue;
		height: 120px;
	}
	.menu2-1{
		flex: 1;
	}
	.menu2-1-top{
		font-size: 20px;
		font-weight: bold;
	}
	.menu2-1-top2{
		margin-top: 10px;
	}
	.menu3{
		margin-top: 30px;
	}
	.menu3-top{
		text-align: center;
	}
	.menu3-top1{
		font-size: 20px;
		font-weight: bold;
	}
	.menu3-top2{
		margin-top: 10px;
		color: #999999;
	}
	.menu4{
		margin-top: 20px;
		display: flex;
		/* align-items: center; */
		justify-content: center;
		margin-top: 20px;
		margin-left: 5%;
		margin-right: 5%;
	}
	.menu4-all{
		width: 22%;
		margin-left: 2%;
		background: #ffffff;
		padding: 45px;
		/* height: 150px; */
	}
	.menu4-all-img1 img{
		width: 200px;
		height: 380px;
	}
	.menu4-all-img2 {
		width: 92px;
		height: 92px;
	}
	/* .menu4-all-img img{
		width: 100%;
		height: 100%;
	} */
	.menu4-all-text{
		margin-top: 20px;
		font-size: 20px;
		font-weight: bold;
	}
	.menu4-all-text2{
		margin-top: 20px;
		color: #999999;
	}
	.menu5{
		margin-top: 20px;
		background-color: #ffffff;
		padding-top: 20px;
		padding-left: 5%;
		padding-right: 5%;
		padding-bottom: 50px;
	}
	.menu5-all{
		width: 22%;
		margin-left: 2%;
		background: #f5f5f5;
		padding: 45px;
		height: 275px;
	}
	.menu5-1{
		margin-top: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 20px;
		
	}
	
	.fotter{
		padding-top: 3%;
		padding-left: 12%;
		padding-right: 12%;
		display: flex;
		background-color: #ffffff;
	}
	.fotter1{
		width: 50%;
		text-align: left;
		line-height: 30px;
	}
	.fotter2{
		width: 50%;
	}
	.fotter2 image{
		width: 50%;
	}
	.fotter1-text{
		font-size: 26px;
		color: rgb(51, 51, 51);
	}
	.fotter1-text2{
		margin-top: 3%;
	}
	.fotter1-text2-4{
		margin-top: 3%;
	}
	
	.color-text {
		color: rgb(30, 80, 174);
	}
	.color-text2 {
		color: rgb(230, 74, 25);
	}
	.color-text3{
		color: rgb(73, 110, 232);
	}
	
</style>